import { clampColumnWidth } from './column-layout';

const DRAG_THRESHOLD_PX = 3;

export type ColumnResizeHandlers = {
  onLive: (width: number) => void;
  onCommit: (width: number) => void;
  onAutoSize: () => void;
};

export function attachColumnResize(
  event: MouseEvent,
  startWidth: number,
  handlers: ColumnResizeHandlers,
  options?: {
    onDragStart?: () => void;
    onDragEnd?: () => void;
  },
) {
  event.preventDefault();
  event.stopPropagation();

  const startX = event.clientX;
  let dragging = false;
  let lastWidth = clampColumnWidth(startWidth);
  let rafId = 0;

  const applyWidth = (next: number) => {
    const clamped = clampColumnWidth(next);
    if (clamped === lastWidth) {
      return;
    }
    lastWidth = clamped;
    handlers.onLive(clamped);
  };

  const onMove = (ev: MouseEvent) => {
    const delta = ev.clientX - startX;
    if (!dragging) {
      if (Math.abs(delta) < DRAG_THRESHOLD_PX) {
        return;
      }
      dragging = true;
      options?.onDragStart?.();
      document.body.classList.add('cs-db-col-resizing');
    }
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => applyWidth(startWidth + delta));
  };

  const onUp = () => {
    cancelAnimationFrame(rafId);
    window.removeEventListener('mousemove', onMove);
    window.removeEventListener('mouseup', onUp);
    if (dragging) {
      document.body.classList.remove('cs-db-col-resizing');
      options?.onDragEnd?.();
      handlers.onCommit(lastWidth);
    } else {
      handlers.onAutoSize();
    }
  };

  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
}
